module.exports = __webpack_public_path__ + "img/phone.37bed1f8.svg";